import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaEventProjectInfo = styled(Flexbox)(
    ({theme: {typography}}) => css`
        ${typography.textSm};
        flex-wrap: wrap;

        & > span > b {
            font-weight: 500;
        }
    `
)

export const StyledExpirationDateInfo = styled.span(
    ({theme: {palette, typography}}) => css`
        ${typography.textXs};
        color: ${palette.neutral[500]};
        text-transform: capitalize;
    `
)
